import React from 'react'
import styles from '../styles.module.css'
import SummaryTable from './Tables/SummaryTable'
import DischargedTable from './Tables/DischargedTable'


const byId = (rows) => {
  const result = {}
  ;(rows || []).forEach(r => {
    if (!result[r.organizationId]) result[r.organizationId] = []
    result[r.organizationId].push(r)
  })
  return result
}


const Table = ({ data }) => {
  if (!data || (!data.summary && !data.discharged)) return null

  const summaryRows = data.summary?.rows || []
  const dischargedById = byId(data.discharged?.rows)

  if (!summaryRows.length) return null

  return (
    <div className={styles.tableBlock}>
      {summaryRows.map(org => {
        const orgId = org.organizationId
        const dischargedRows = dischargedById[orgId] || []
        return (
          <div key={orgId} className={styles.orgBlock}>
            <SummaryTable row={org} />
            <DischargedTable rows={dischargedRows} organizationName={org.organizationName} />
          </div>
        )
      })}
    </div>
  )
}

export default Table
